import { useState } from "react";
import AdminPage from "./components/AdminPage";

import AdminTable from "./components/AdminTable";
import PrimaryButton from "./components/PrimaryButton";

import { executeAdminScript } from "./api/scriptsApi";

export default function Scripts() {
  const scriptsList = [
    { name: "Refresh Matches", path: "/matches/refresh" },
    ,
    { name: "Update Odds", path: "/update/odds" },
    { name: "Verify Outcomes", path: "/verify-outcomes/run-verification" },
    { name: "Update Standings", path: "/matches/updatestandings" },
    { name: "Update H2H", path: "/update/h2h" },
    { name: "Update Last 10", path: "/update/last10" },
    { name: "Clear Cache", path: "/cleanup/oldmatches" },
  ];

  const [selectedDb, setSelectedDb] = useState(
    scriptsList.reduce((acc, script) => {
      acc[script.path] = "test";
      return acc;
    }, {}),
  );

  const [loadingScripts, setLoadingScripts] = useState({});

  const executeScript = async (scriptPath) => {
    const database = selectedDb[scriptPath];

    try {
      setLoadingScripts((prev) => ({
        ...prev,
        [scriptPath]: true,
      }));

      const result = await executeAdminScript(scriptPath, database);

      alert(`Script executed successfully: ${result.message || "Done"}`);
    } catch (error) {
      console.error(error);
      alert(`Error executing script: ${error.message}`);
    } finally {
      setLoadingScripts((prev) => ({
        ...prev,
        [scriptPath]: false,
      }));
    }
  };

  return (
    <AdminPage title='Scripts' subtitle='Execute maintenance scripts.'>
      <AdminTable headers={["Script", "Database", "Action"]}>
        {scriptsList.map((script) => (
          <tr
            key={script.path}
            className='border-t border-green-500/10 hover:bg-white/5 transition'
          >
            <td className='p-4 text-white'>{script.name}</td>

            <td className='p-4'>
              <select
                value={selectedDb[script.path]}
                onChange={(e) =>
                  setSelectedDb({
                    ...selectedDb,
                    [script.path]: e.target.value,
                  })
                }
                className='bg-gray-800 text-white border border-gray-600 rounded-lg px-3 py-2'
              >
                <option value='test'>Test</option>

                <option value='live'>Live</option>
              </select>
            </td>

            <td className='p-4'>
              <PrimaryButton
                disabled={loadingScripts[script.path]}
                onClick={() => executeScript(script.path)}
                className={
                  loadingScripts[script.path]
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }
              >
                {loadingScripts[script.path] ? "Running..." : "Execute"}
              </PrimaryButton>
            </td>
          </tr>
        ))}
      </AdminTable>
    </AdminPage>
  );
}
